import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n.use(LanguageDetector).init({
  resources: {
    en: {
      translations: {
        navigationItemHome: "Home",
        navigationItemRegister: "Register",
        navigationItemParticipants: "Participants",
        navigationItemMedia: "Media",
        navigationItemSponsors: "Sponsors",
        navigationItemContact: "Contact",
        navigationItemAccount: "Account",
        navItemLogout: 'Logout',
        navItemLobby: 'Lobby',
        navItemBooths: 'Green Pavilion',
        navItemGreenForums: 'Green Forums',

        RegisterBtnDesk: "REGISTER NOW",
        LobbyBtnDesk: "LOBBY",
        GreenPavBtnDesk: "GREEN PAVILION",
        GreenForBtnDesk: "GREEN FORUMS",
        B2bBtnDesk: "B2B",
        supportedByText: "Supported By",

        countDownTitle: "We bring the <strong>Green Business</strong> Partners to You!",
        countDownDays: "Days",
        countDownHours: "Hours",
        countDownMinutes: "Minutes",
        countDownSeconds: "Seconds",
        countDownCompleted: "Countdown Completed",
        december: 'December',

        aboutTitle: "About",
        aboutSubtitle: "Green Business Expo",
        aboutParagraph1: "Green Business Expo serves as an ideal networking platform for business sector, government institutions, financial institutions and international donors.",
        aboutParagraph2: "Green Business Expo during the last edition of 2019 had:",
        aboutUnOrderedList1: "<strong>47 participating companies.</strong>",
        aboutUnOrderedList2: "The fair had about <strong>6,630 visitors</strong>, while the exhibiting companies reported about <strong>673 valuable contacts.</strong>",
        aboutUnOrderedList3: "<strong>1,205,900 € sales</strong> were declared for potential sale and purchase agreements.",
        aboutParagraph3: "If you want more reach/business leads for your business and want to promote your presence, then Green Business Expo is the place!",
        aboutImageDescription: "Image from the fourth edition of the Green Business Expo (formerly Green Business Expo)",

        virtualBoothsTitle: "65+ virtual booths",
        virtualBoothsSubtitle: "with browsable product catalogues and online standing by company representatives to answer your questions. ",
        construction: "Construction and eco-interior",
        energyEfficiency: "Energy efficiency",
        renewableEnergy: "Renewable energy",
        recycling: "Recycling",

        whyAttendTitle: "Why Attend?",
        whyAttendParagraph1: "Engage and network with top industry leaders in the Western Balkans region through interactive B2B meetings and spontaneous video/chat capabilities at our virtual booths at Green Pavilion.",
        whyAttendParagraph2: "Learn about the latest Green Business trends, practices, technology and services directly by industry experts at our Green Forums, and much more!",
        theBestPartTitle: "The best part?",
        theBestPartParagraph1: "You do not have to leave your desk, \n" +
          " we will come back to you through your \n" + "PCs, mobiles and ipads.",
        theBestPartParagraph2: "Do not miss the opportunity to join the biggest green event in the Western Balkans!",

        videoSummary: "Summarized video from the last year, 4th edition of the <strong>Green Exhibition</strong> (formerly known as Green Fest) ",

        registerBtn: "Register Now",
        businessBtn: "Exhibitor",
        visitorBtn: "Visitor",
        nameAndLastnameField: "Name and Lastname",
        eMailField: "E-mail",
        passwordField: "Password",
        jobPositionField: "Job Position",
        companyNameField: "Company Name",
        sectorField: "Sector",
        numberOfEmployeesField: "Number of Employees",
        phoneNumberField: "Phone Number",
        countryAndCityField: "Country and City",
        countryField: 'Country',
        cityField: 'City',
        firstNameField: "First Name",
        lastNameField: "Last Name",
        confirmPasswordField: "Confirm Password",

        standPreference: "Booth Preference",
        standPreferenceSubtitle: "please tick a box",
        prefereThisBtn: "I prefer this",
        platinium: "Platinium",
        premium: "Premium",
        standard: "Standard",
        submitFormBtn: "Submit form",

        footerItemLobby: "Lobby",
        footerItemGreenPavilion: "Green Pavilion",
        footerItemGreenForums: "Green Forums",
        footerItemB2B: "B2B",
        newsletterTitle: "Newsletter",
        newsletterText: "Sign up to our news letter and get the latest updates, news, and all the other important info related to GreenKosovo first!",
        newsletterField: "E-Mail Adress",
        sendBtn: "Send",

        FAQText: "Frequently asked questions",
        accordionTitle1: "What is Green Business Expo?",
        accordionText1: "The Green Business Expo is the only fair&conferences event in Kosovo dedicated to the green\n" +
          "business sector, organized by Kosovo Manufacturing Club (www.klubiprodhuesve.org). The main aim \n" +
          "of the event is to provide the necessary support for the development of the green businesses and\n" +
          "addressing the challenges that these businesses are facing.\n" +
          "The event serves as a networking platform for green business sector, government institutions and\n" +
          "international donors.",
        accordionTitle2: "What is this VIRTUAL edition?",
        accordionText2: "This year, due to the COVID-19 situation, it has been decided that the event will be held virtually.\n" +
          "Virtual expos are designed for online use, designed to resemble physical expos by including lobby,\n" +
          "Green Forums (exhibit hall), B2B matchmaking, Green Forums (experts’ webinars) and Product\n" +
          "Presentation Virtual Stage. There are virtual booths for displaying products and services.",
        accordionTitle3: "What is a virtual booth?",
        accordionText3: "The virtual booths at the Green Pavilion, offer the opportunity to the visitors to get acquainted with\n" +
          "exhibiting companies and their products from the comfort of her/his office. Like a physical booth,\n" +
          "the virtual booth is designed to involve customers, investors, and the media so that they are more \n" +
          "aware of the exhibitor’s products or services. An online visitor can view company’ videos, check \n" +
          "catalogues, or chat/ video call with exhibitor representatives in real time, attend Green Forums \n" +
          "(webinars) and network with other visitors from the office and by having all in one place and without\n" +
          "the need to move or further search \n" +
          "This time the visitors will be from all over the region and all over the world!",
        accordionTitle4: "What can I do at the Green Business Expo?",
        accordionText4: "If you want more reach/business leads for your business and want to promote your presence and be\n" +
          "informed about green businesses, then Green Business Expo is the place!\n" +
          "From the comfort of your desk chair, you can exchange contact information and interact with clients,\n" +
          "investors and media.\n" +
          "At this online event you will be able to:",
        accordionTextUl1: "Visit exhibitors and interact one-on-one with clients, investors and media;\n",
        accordionTextUl2: "Have the opportunity to schedule B2B meetings;",
        accordionTextUl3: "Check online product catalogues, brochures and videos of exhibiting companies;",
        accordionTextUl4: " Download product catalogues and brochures on your computer for further reference;",
        accordionTextUl5: "Connect with your industry peers through audio, video and text message;",
        accordionTextUl6: "Attend expert webinars and keep up-to date with the newest trends and 'green products, practices and technologies.'",
        accordionTitle5: "How do I register for Green Business Expo?",
        accordionText5: "To visit the event, first you need to be registered. To register, visit\n" +
          "www.greenkosovo.com/businessexpo and complete the “Register now” form – exhibitors or visitor.\n" +
          "Fill out the online form to complete your registration. Once registered, you can access the digital\n" +
          "event on December 1-2, 2020. You will also receive a notification e-mail confirming your registration\n" +
          "and indiciating your username and password.\n" +
          "You can also join the event through your social accounts such as Facebook, Instagram and LinkedIn\n" +
          "by clicking on the corresponding icons at the ““Register now” form.",
        accordionTitle6: "I registered for the Green Business Expo, but I am unable to log in?",
        accordionText6: "Green Business Expo will be live online on December 1-2, 2020. Once the event is up and running,\n" +
          "you can use the login information (username and password) www.greenkosovo.com/businessexpo\n" +
          "created at the time of registration to virtually participate in the event. (If you have forgotten your\n" +
          "password, reset it using the ‘forgot password’ link on the event homepage.",
        accordionTextUl7: " You can also join the event, through your social accounts such as Facebook, Instagram and LinkedIn",
        accordionTitle7: "How long will the Green Business Expo last?",
        accordionText7: "The Green Business Expo, itself, is a two-day event scheduled for December 1-2, 2020. No one will\n" +
          "be able to login before this date.\n",
        accordionTextUl8: "After the event date, all virtual booths will remain open and active for 3 months and available online\n" +
          "24/7.",

        requiredField: 'This field is required',
        mustBeNumberValidation: 'Must be number',
        invalidEmailValidation: 'Invalid e-mail',
        passwordLengthValidation: 'Password must be at least 6 characters',
        confirmPasswordLengthValidation: 'Password confirmation must be at least 6 characters',
        passwordsMustMatch: 'Passwords must match',
        mustApproveGDPR: 'Must approve GDPR text',

        GDPRText: 'I approve GDPR text (General Data Protection Regulation)',

        somethingWentWrong: 'Something went wrong',
        contactFixedBtn: "Contact Us",

        boothsBtn1: 'PARTNERS',
        boothsBtn2: 'CONSTRUCTION & ECO-INTERIOR',
        boothsBtn3: 'ENERGY EFFICIENCY',
        boothsBtn4: 'RENEWABLE ENERGY',
        boothsBtn5: 'RECYCLE',
        floorBtn: 'Floor',

        browseText: 'BROWSE ALL THE CATEGORIES',

        pBooth1: 'WELCOME TO',
        pBooth2: 'KLUBI I PRODHUESVE TE KOSOVES',
        boothBtn1: 'BROWSE THE CATALLOGUE',
        boothBtn2: 'REQUEST A QUOTE',
        boothBtn3: 'SCHEDULE A MEETING',
        boothBtn4: 'LEAVE A BUSINESS CARD',

        loginWelcome: 'Welcome',
        loginViaSocial: 'Login via social media',
        loginText1: 'If you do not have an account, you can register <1><strong>here</strong></1>',
        loginBtn1: 'LOGIN',
        loginPassword: 'Password',
        loginEmail: 'E-mail',
        loginFacebook: 'Facebook',
        loginLinkedIn: 'LinkedIn',
        forgotPassTxt: 'Forgot Password?',
        btnResetPass: 'Reset Password',
        loginModalTxt: 'Write your email here:',

        boothRequest: 'Request a quote',
        boothNetworking: 'Networking',

        boothNameInput: 'Name',
        boothEmailInput: 'E-mail',
        boothPhoneInput: 'Phone',
        boothSubjectInput: 'Subject',
        boothMessageInput: 'Message',

        boothSuccess: 'Success',
        boothBusinessCard: 'Business Card was successfully sent to the company.',

        productPresText: 'PRODUCT PRESENTATION',
        btnPres: 'Back to Lobby',

        lobbyForumBtn: 'Green Forums',
        lobbyPavilionBtn: 'Green Pavilion',
        lobbyProductPresentationBtn: 'Product Presentation',
        lobbyHelpDesk: 'Help Desk',
        lobbyOrganizedBy: 'Organized by',
        lobbySupportedBy: 'Supported by',

        dayOneTitle: 'Day 1',
        dayTwoTitle: 'Day 2',

        d11Text1: 'Opening Ceremony of Green Festival',
        d11Text2: 'Speakers (Pre-recorded videos): ',
        d11Text3: ' – Executive Director of Kosovo Manufacturing Club',
        d11Text4: ' – Ambassador of Embassy of the Germany in Prishtina',
        d11Text5: ' – Ambassador of Embassy of the Kingdom of the Netherlands in Prishtina ',
        d11Text6: ' – CEO of ProCredit Bank, Kosovo',
        d11Text7: ' – Deputy/ Chairperson of the Sustainable Development Council ',
        d11Title2: 'Challenges for Sustainable Development in Kosovo',

        d12Text1: ' – Manager of Kosovo Project for Energy Efficiency at GIZ Kosovo ',
        d12Text2: ' – Director of the Department of spatial planning, housing and construction at Ministry of Environment and Spatial Planning',
        d12Text3: ' – Head of Environmental Unit at Procredit Bank Kosovo',
        d12Text4: ' – Energy efficiency expert, Albania',
        d12Text5: ' – Senior Energy Specialist at World Bank',
        d12Text6: ' – Architect and Urban Planner, Kosovo',

        d12Title1: 'Improving energy efficiency in buildings: ',
        d12Title2: 'Challenges and opportunities in the Western Balkans countries ',
        d12PanelText1: 'Panelists:',
        d12Title3: 'General Discussion',
        d12TextQuest: 'Question and Answer Session with the audience',

        d13Title1: 'Construction and Demolition Waste in Kosovo/ Region: ',
        d13Title2: 'From a waste challenge to a resource opportunity ',
        d13Text1: '- The Kosovo Corporate Social Responsibility Network',
        d13Text2: '– Head of the Association of Construction Companies',
        d13Text3: '– Founder and Executive Director of Green Energy Kosova',
        d13Text4: '– Chief of Structure at Marigona Hill',
        d13Text5: '– MPhD. Professor - UNESCO-IHE institute for water education in Delft',
        d13Text6: '– Associate of prof. Marteen A. Siebel',

        d21Title1: 'A green success story from Netherland ',
        d21Text1: 'Green city, recycling, and circular economy (short presentation) ',
        d21Text2: 'Embassy of the Kingdom of the Netherlands, Kosovo. ',

        d22Title1: 'Tackling climate change through Green Public Procurement',
        d22Text1: '– General Secretary of Kosovo Manufacturing Club',
        d22Text2: '– Director of the Department of Environmental and Water Protection at Ministry of Economy and Environment, Environment and Spatial Planning',
        d22Text3: '– Public Procurement Regulatory Committee ',
        d22Text4: '– Procurement Expert, Kosovo ',
        d22Text5: '– Sustainability Manager at Sustainability Leadership Kosova',

        d23Title1: 'The positive effects of green recovery programs on job creation and industry policy',
        d23Text1: '– Managing Director and founder of the consulting firm IET – International Energy Transition GmbH',
        d23Text2: 'German-Kosovar Business Association (OEGJK-KDWV)/ Network for Clean Energy Businesses (N4CEB).',

        btnForumsJoin: 'Join Now',
        btnForumsJoinAL: 'Join Now (AL)',
        btnForumsJoinEN: 'Join Now (EN)',
        btnForumsJoinTrans: 'Translator incl.',

        calendarScheduled:'You have already scheduled with this company!',
        scheduleMeeting: 'Schedule a meeting in',
        calendarYes: 'Yes',
        calendarNo: 'No',

        busyVideoCall1: 'The business is busy for the moment with another client.',
        busyVideoCall2: 'Please, wait for a few of minutes or ‘schedule a B2B meeting’.',
        busyVideoCall3: 'Thank you!',
      }
    },
    sq: {
      translations: {
        navigationItemHome: "Ballina",
        navigationItemRegister: "Regjistrohu",
        navigationItemParticipants: "Pjesëmarrësit",
        navigationItemMedia: "Media",
        navigationItemSponsors: "Sponsorët",
        navigationItemContact: "Kontakti",
        navigationItemAccount: "Llogaria",
        navItemLogout: 'Shkyçu',
        navItemLobby: 'Holli',
        navItemBooths: 'Pavijoni i Gjelbër',
        navItemGreenForums: 'Forume të Gjelbra',

        RegisterBtnDesk: "REGJISTROHU",
        LobbyBtnDesk: "HOLLI",
        GreenPavBtnDesk: "PAVIJONI I GJELBËR",
        GreenForBtnDesk: "FORUME TË GJELBRA",
        B2bBtnDesk: "B2B",
        supportedByText: "Mbështetur nga",

        countDownTitle: "Ne sjellim Partnerët e <strong>Biznesit të Gjelbër</strong> tek Ju!",
        countDownDays: "Ditë",
        countDownHours: "Orë",
        countDownMinutes: "Minuta",
        countDownSeconds: "Sekonda",
        countDownCompleted: "Countdown Completed",
        december: 'Dhjetor',

        aboutTitle: "Rreth",
        aboutSubtitle: "Green Business Expo",
        aboutParagraph1: "Green Business Expo shërben si një platformë ideale rrjetëzimi për bizneset e gjelbra, institucionet qeveritare, institucionet financiare dhe donatorët ndërkombëtarë.",
        aboutParagraph2: "Green Business Expo gjatë edicionit të kaluar të vitit 2019 kishte:  ",
        aboutUnOrderedList1: "<strong>47 kompani pjesëmarrëse;</strong>",
        aboutUnOrderedList2: "Panairi kishte rreth <strong>6,630 vizitorë</strong>, kurse kompanitë ekspozuese raportuan rreth  <strong>673 kontakte të vlefshme.</strong>",
        aboutUnOrderedList3: "<strong>1,205,900 € shitje, </strong> të deklaruara nga marrëveshjet të mundshme potenciale për shitblerje.",
        aboutParagraph3: "<strong> Nëse dëshironi më shumë kërkesa për biznesin e juaj dhe dëshironi të promovoni prezencën e juaj, atëherë Green Business Expo është vendi i duhur!</strong>",
        aboutImageDescription: "Pamje nga edicioni i katërt i Biznesit të Gjelbër Expo (i njohur më parë si Festivali i Gjelbër)",

        virtualBoothsTitle: "65+ shtande virtuale",
        virtualBoothsSubtitle: "me mundësi të shfletimit të katalogëve të produkteve dhe prezantim live nga përfaqësuesit e kompanive ekspozuese te secili shtand për të i’u përgjigjur pyetjeve tuaja.",
        construction: "Ndërtimi dhe eko-enterieri",
        energyEfficiency: "Efiçienca e energjisë",
        renewableEnergy: "Energjia e riperteritshme",
        recycling: "Riciklimi",

        whyAttendTitle: "Pse të vizitoni?",
        whyAttendParagraph1: "Krijoni lidhje biznesi dhe rrjetëzohuni me liderët e industrisë në rajonin e Ballkanit Perëndimor përmes takimeve interaktive B2B dhe video bisedave spontane të drejtpërdrejta në stendat tona virtuale në Pavilionin e Gjelbër. ",
        whyAttendParagraph2: "Informohuni rreth trendeve të tanishme dhe ardhshme, praktikave, teknologjisë dhe shërbimeve më të fundit të Biznesit të Gjelbër direkt nga ekspertë të industrisë në Forumet Gjelbra, dhe  shumë më tepër!",
        theBestPartTitle: "Pjesa më e mirë?",
        theBestPartParagraph1: "Ju nuk keni nevoje të lini zyrën tuaj, ne do të vijmë tek ju përmes kompjuterëve, telefonave dhe tabletëve tuaj.",
        theBestPartParagraph2: "Mos e humbni mundësinë për t'u bashkuar në ngjarjen më të madhe të gjelbër në Ballkanin Perëndimor!",

        videoSummary: "Video përmbledhëse nga viti i kaluar, edicioni i 4të i Green Business Expo (i njohur më parë si Festivali i Gjelbër) ",

        registerBtn: "Regjistrohu",
        businessBtn: "Ekspozues",
        visitorBtn: "Vizitorë",
        nameAndLastnameField: "Emri dhe Mbiemri",
        eMailField: "E-mail",
        passwordField: "Fjalëkalimi",
        jobPositionField: "Pozita e Punës",
        companyNameField: "Emri i Kompanisë",
        sectorField: "Sektori",
        numberOfEmployeesField: "Numri i Punëtorëve",
        phoneNumberField: "Telefoni",
        countryAndCityField: "Shteti dhe Qyteti",
        countryField: 'Shteti',
        cityField: 'Qyteti',
        firstNameField: "Emri",
        lastNameField: "Mbiemri",
        confirmPasswordField: "Konfirmo Fjalëkalimin",

        standPreference: "Preferenca e Shtandit",
        standPreferenceSubtitle: "ju lutemi zgjedheni një kuti",
        prefereThisBtn: "Preferoj këtë",
        platinium: "Platinium",
        premium: "Premium",
        standard: "Standard",
        submitFormBtn: "Dërgo",

        footerItemLobby: "Holli",
        footerItemGreenPavilion: "Pavijoni i Gjelbër",
        footerItemGreenForums: "Forume të Gjelbërta",
        footerItemB2B: "B2B",
        newsletterTitle: "Newsletter",
        newsletterText: "Regjistrohuni në letrën tonë të lajmeve dhe merrni azhurnimet më të fundit, lajmet, dhe të gjitha informacionet e tjera të rëndësishme në lidhje me Kosovën e Gjelbër së pari!",
        newsletterField: "E-Mail Adresa",
        sendBtn: "Dërgo",

        FAQText: "Pyetjet më të shpeshta",
        accordionTitle1: "Çka është Green Business Expo?",
        accordionText1: "Green Business Expo është ngjarja e vetme e panairit&konferencave në Kosovë, e cili i dedikohet\n" +
          "sektorit të biznesit të gjelbër dhe organizohet nga Klubi i Prodhuesve të Kosovës (\n" +
          "www.klubiprodhuesve.org ) . Qëllimi i përgjithshëm i ngjarjës është të avancojë zhvillimin dhe rritjen\n" +
          "e bizneseve të gjelbra dhe të adresoj sfidat me të cilat përballen këto biznese.\n" +
          "Green Business Expo ofron një platformë rrjetëzimi për bizneset e gjelbra, institucionet qeveritare\n" +
          "dhe donatorët ndërkombëtarë.",
        accordionTitle2: "Çfarë është ky edicion VIRTUAL?",
        accordionText2: "Këtë vit, për shkak të situatës së COVID-19, është vendosur që ngjarja të mbahet virtualisht. Panairet\n" +
          "virtuale janë të dizajnuara për përdorim në internet, për t’iu ngjajtur panaireve fizike duke përfshirë\n" +
          "pjesën hyrëse, Forumet e Gjelbra (salla e kompanive ekspozuese), B2B takimet, Forumet e Gjelbra\n" +
          "(konferenca online me ekspertë të fushës) dhe Pjesa Virtuale e Prezantimit të Produkteve. Këtu\n" +
          "\n" +
          "përfshihen edhe shtandet virtuale për prezantimin e produkteve dhe shërbimeve të kompanive\n" +
          "pjesëmarrëse.",
        accordionTitle3: "Çfarë është një shtand virtual?",
        accordionText3: "Shtandet virtuale në Pavilionin e Gjelbër, ofrojnë mundësinë që vizitorët të njihen kompanitë\n" +
          "ekspozuese nga komoditeti i zyrës tuaj. Ashtu si një shtand fizik, shtandi virtuale është krijuar për të\n" +
          "përfshirë klientët, investitorët dhe mediat në mënyrë që ata të jenë më të vetëdijshëm për\n" +
          "produktet ose shërbimet e ekspozuesve. Një vizitor mund të shikojë videot e kompanisë, të shfletoj\n" +
          "katalogët, ose të bisedoj online edhe përmes kamerës me përfaqësues të ekspozuesit (njëjti sikurse\n" +
          "në shtand fizik), të marrë pjesë në Forumet e Gjelbrta (konferenca online) dhe të lidhet me vizitorë\n" +
          "të tjerë nga zyrja dhe të gjitha në një vend dhe pa nevojën e lëvizjes ose kërkimit të mëtejshëm. Këtë\n" +
          "herë vizitorët do të jenë nga i tërë rajoni dhe bota!",
        accordionTitle4: "Çfarë mund të bëj në Green Business Expo?",
        accordionText4: "Nëse dëshironi më shumë kërkesa për biznesin e juaj dhe dëshironi të promovoni prezencën e juaj,\n" +
          "atëherë Green Business Expo është vendi i duhur!\n" +
          "Nga komoditeti i tavolinës tuaj, ju mund të shkëmbeni informata dhe të krijoni kontakte me klientët,\n" +
          "blerësit dhe investitorët e mundshëm.\n" +
          "Në këtë ngjarje online ju do të jeni në gjendje të:\n",
        accordionTextUl1: "Vizitoni ekspozuesit dhe ndërveproni një-me-një me klientët, investitorët dhe media;",
        accordionTextUl2: "Të caktoni takime B2B;",
        accordionTextUl3: "Shfletoni katalogët, broshurat dhe videot e produkteve online të kompanive ekspozuese;",
        accordionTextUl4: "Shkarkoni katalogë dhe broshura të produkteve në kompjuterin tuaj për referencë të\n" +
          "mëtutjeshme;",
        accordionTextUl5: "Lidhuni online me kolegët tuaj të biznesit përmes audio, video dhe mesazheve me tekst;",
        accordionTextUl6: "Merrni pjesë në konferenca me ekspertë të fushave dhe informohuni mbi trendet më të reja të\n" +
          "'produkteve të gjelbra, praktikave dhe teknologjive të gjelbra.'",
        accordionTitle5: "Si mund të vizitoj/ regjistrohem në Green Business Expo?",
        accordionText5: "Për të vizituar këtë ngjarje, së pari duhet të regjistroheni. Për t'u regjistruar, vizitoni\n" +
          "www.greenkosovo.com/businessexpo dhe plotësoni formën Regjistrohu tani - ekspozues ose\n" +
          "vizitor. Plotësoni formën online për të përfunduar regjistrimin tuaj. Pasi të regjistroheni, mund të\n" +
          "kyqeni online gjatë kohës që do të mbahet ngjarja me 1-2 Dhjetor, 2020. Ju gjithashtu do të pranoni\n" +
          "njënjoftim përmes email-ës që konfirmon regjistrimin tuaj dhe tregon emrin e përdoruesit dhe\n" +
          "fjalëkalimin tuaj.\n" +
          "Po ashtu, ju mund të vizitoni këtë ngjarje përmes llogarive tuaja sociale si Facebook, Instagram dhe\n" +
          "LinkedIn duke klikuar në ikonat përkatëse në formën Regjistrohu tani.",
        accordionTitle6: "Unë u regjistrova për Green Business Expo, por nuk jam në gjendje të kyçem?",
        accordionText6: "Green Business Expo do të jetë mbahet online drejtpërdrejt me 1-2 Dhjetor, 2020 në\n" +
          "www.greenkosovo.com/businessexpo . Pasi eventi do të lansohet në datë 1 Dhjetor, ju mund të\n" +
          "përdorni informacionin e hyrjes (emri i përdoruesit dhe fjalëkalimi) i krijuar në kohën e regjistrimit\n" +
          "për tu kyqur në ngjarje. (Nëse e keni harruar fjalëkalimin tuaj, rivendoseni duke përdorur ikonën\n" +
          "‘fjalëkalimi i harruar’ në faqen kryesore të ngjarjes.\n",
        accordionTextUl7: "Ju gjithashtu mund të bashkoheni në këtë ngjarje, përmes llogarive tuaja sociale si Facebook,\n" +
          "Instagram dhe LinkedIn.",
        accordionTitle7: "Sa do të zgjasë Green Business Expo?",
        accordionText7: "Green Business Expo është një ngjarje dy-ditore, e cila do të mbahet me 1-2 Dhjetor, 2020. Para\n" +
          "kësaj date (1 Dhjetor) askush nuk do të jetë në gjendje të kyçet.\n",
        accordionTextUl8: "Pas datave të lartë cekura, të gjitha shtandet virtuale do të qëndrojnë të hapura dhe aktive për 3\n" +
          "muajt e ardhshme dhe do të jenë të disponueshme për tu vizituar24/7.",

        requiredField: 'Obligative',
        mustBeNumberValidation: 'Duhet të jetë numër',
        invalidEmailValidation: 'Email i pavlefshëm',
        passwordLengthValidation: 'Fjalëkalimi duhet ti ketë të paktën 6 karaktere',
        confirmPasswordLengthValidation: 'Konfirmimi i fjalëkalimit duhet ti ketë së paku 6 karaktere',
        passwordsMustMatch: 'Fjalëkalimet duhet të përputhen',
        mustApproveGDPR: 'Duhet aprovimi i GDRP',

        GDPRText: 'Aprovoj tekstin GDPR (Rregullorja e Përgjithshme e Mbrojtjes së të Dhënave)',

        somethingWentWrong: 'Diçka nuk shkoj në rregull',
        contactFixedBtn: "Kontakti",

        boothsBtn1: 'PARTNERËT',
        boothsBtn2: 'NDËRTIMI DHE EKO-ENTERIERI',
        boothsBtn3: 'EFIÇIENCA E ENERGJISË',
        boothsBtn4: 'ENERGJIA E RIPERTERITSHME',
        boothsBtn5: 'RICIKLIMI',
        floorBtn: 'Kati',

        browseText: 'SHFLETONI TË GJITHA KATEGORITË',

        pBooth1: 'MIRËSEVINI',
        pBooth2: 'KLUBI I PRODHUESVE TE KOSOVES',
        boothBtn1: 'SHFLETO KATALOGUN',
        boothBtn2: 'KËRKO OFERTË',
        boothBtn3: 'CAKTO TAKIM',
        boothBtn4: 'LINI KARTËVIZITËN',

        loginWelcome: 'Mirësevini',
        loginViaSocial: 'Kyçu përmes rrjeteve sociale',
        loginText1: 'Nëse nuk keni llogari, mund të regjistroheni <1><strong>këtu</strong></1>',
        loginBtn1: 'KYÇU',
        loginPassword: 'Password',
        loginEmail: 'E-mail',
        loginFacebook: 'Facebook',
        loginLinkedIn: 'LinkedIn',
        forgotPassTxt: 'Keni harruar fjalëkalimin?',
        btnResetPass: 'Rivendos Fjalëkalimin',
        loginModalTxt: 'Shkruani email-in këtu',

        boothRequest: 'Kërko ofertë',
        boothNetworking: 'Networking',

        boothNameInput: 'Emri',
        boothEmailInput: 'E-mail',
        boothPhoneInput: 'Telefoni',
        boothSubjectInput: 'Subjekti',
        boothMessageInput: 'Mesazhi',

        boothSuccess: 'Sukses',
        boothBusinessCard: 'Kartëvizita është dërguar me sukses tek kompania',

        productPresText: 'PREZANTIMI I PRODUKTEVE',
        btnPres: 'Kthehu në Lobby',
        
        lobbyForumBtn: 'Forumet e Gjelbra',
        lobbyPavilionBtn: 'Pavijoni i Gjelbër',
        lobbyProductPresentationBtn: 'Prezantimi i Produkteve',
        lobbyHelpDesk: 'Recepcion',
        lobbyOrganizedBy: 'Organizuar nga:',
        lobbySupportedBy: 'Mbështetur nga:',

        dayOneTitle: 'Dita 1',
        dayTwoTitle: 'Dita 2',

        d11Text1: 'Ceremonia e hapjes',
        d11Text2: 'Fjalimet (Videot e regjistruara paraprakisht): ',
        d11Text3: ' – Drejtor Ekzekutiv i Klubit të Prodhuesve të Kosovës',
        d11Text4: ' – Ambasador i Gjermanisë në Prishtinë ',
        d11Text5: ' – Ambasadore e Mbretërisë së Holandës në Prishtinë',
        d11Text6: ' – Drejtoreshë Ekzekutive e ProCredit Bank, Kosovë',
        d11Text7: ' – Deputete/ Kryesuese e Këshillit për Zhvillim të Qëndrueshëm në Kosovë.',
        d11Title2: 'Sfidat për zhvillim të qëndrueshëm në Kosovë ',

        d12Text1: ' – Menaxher i Projektit të Efiçiencës së Energjisë në GIZ Kosovë ',
        d12Text2: ' – Udhëheqës i Departamentit të Planifikimit Hapësinor, Ndërtimit dhe Banim, Ministria e Mjedisit dhe Planifikimit Hapësinor',
        d12Text3: ' – Udhëheqës i Njësisë Mjedisore në ProCredit Bankën, Kosovë',
        d12Text4: ' – Ekspert i efiçiencës së energjisë, Shqipëri',
        d12Text5: ' – Specialist i lartë i energjisë në Bankën Botërore, Kosovë ',
        d12Text6: ' – Arkitekte dhe planifikuese urbane, Kosovë',
        d12Title1: 'Përmirësimi i efiçiencës së energjisë në ndërtesa: ',
        d12Title2: 'Sfida dhe mundësitë në Kosovë dhe në vendet e Ballkanit Perëndimor',
        d12PanelText1: 'Panelistë:',
        d12Title3: 'Diskutim i përgjithshëm',
        d12TextQuest: 'Seancë pyetjesh dhe përgjigjesh me audiencën',

        d13Title1: 'Mbeturinat e Ndërtimit dhe Demolimit në Kosovë / Rajon: ',
        d13Title2: 'Nga një sfidë e mbeturinave në një mundësi burimesh',
        d13Text1: '- Rrjeti për Përgjegjësi Shoqërore e Korporatave në Kosovë',
        d13Text2: '– Kryetar i Shoqatës së Ndërmarrjeve Ndërtimore',
        d13Text3: '– Themelues dhe Drejtor Ekzekutiv i Green Energy Kosova',
        d13Text4: '– Udhëheqës i Strukturës në Marigona Hill',
        d13Text5: '– PhD. Profesor - UNESCO-IHE për edukimin e ujërave në Delft',
        d13Text6: '– Bashkëpunëtor i prof. Maarten A. Siebel',

        d21Title1: 'Një histori suksesi e nga Holanda ',
        d21Text1: 'Qyteti i gjelbër, riciklimi dhe ekonomia rrethore (prezantim i shkurtër).',
        d21Text2: 'Ambasada e Mbretërisë së Holandës, Prishtinë.',

        d22Title1: 'Trajtimi i ndryshimeve klimatike përmes Prokurimit Publik të Gjelbër',
        d22Text1: '– Sekretar Gjeneral në Klubin e Prodhuesve të Kosovës',
        d22Text2: '– Udhëheqës i Departamentit të Mbrojtjes së Mjedisit dhe Ujërave, Ministria e Ekonomisë dhe Ambientit',
        d22Text3: '– Udhëheqës i Sektorit për Monitorim, Komisioni Rregullativ i Prokurimit Publik',
        d22Text4: '– Ekspert i Prokurimit, Kosovë ',
        d22Text5: '– Menaxhere e Qëndrueshmërisë në Sustainability Leadership Kosova',

        d23Title1: 'Programet e gjelbërta të rimëkëmbjes dhe efektet pozitive në krijimin e vendeve të punës dhe politika e industrisë',
        d23Text1: '– Drejtor Menaxhues dhe themelues I firmës këshilluese IET - International Energy Transition GmbH',
        d23Text2: 'Oda Ekonomike Gjermano-Kosovare (OEGJK)/ Rrjeti për bizneset e energjisë së pastër (N4CEB)',

        btnForumsJoin: 'Merr pjesë tani',
        btnForumsJoinAL: 'Merr pjesë (AL)',
        btnForumsJoinEN: 'Merr pjesë (EN)',
        btnForumsJoinTrans: 'Me Përkthyes',

        calendarScheduled: 'Ju tashmë e keni caktuar nje takim',
        scheduleMeeting: 'A dëshironi të caktoni takim ne ora',
        calendarYes: 'Po',
        calendarNo: 'Jo',
        
        busyVideoCall1: 'Për momentin biznesi është i zënë në takim me klient tjetër.',
        busyVideoCall2: 'Ju lutem prisni apo caktoni takim tek butoni ‘Cakto takim’.',
        busyVideoCall3: 'Faleminderit shumë!',
      }
    },
  },
  lng: "sq",
  fallbackLng: "sq",
  debug: true,
  ns: ["translations"],
  defaultNS: "translations",
  keySeparator: false,
  interpolation: {
    escapeValue: false,
    formatSeparator: ","
  },
  react: {
    wait: true
  }
});

export default i18n;